import { Helmet, HelmetProvider } from "react-helmet-async";
import FooterComponent from "../../views/footer/FooterComponent";
import NavbarMain from "../../views/navbar/NavbarMain";
import MainComponent from "../../views/product";

export default function ProductPage(props) {
    return (
        <>
            <MainComponent />
        </>
    );
}